/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is hexadecimal shown in uppercase or lowercase?`)
};

const es_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Se muestra el hexadecimal en mayúsculas o minúsculas?`)
};

const de_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird Hexadezimal in Groß- oder Kleinschreibung angezeigt?`)
};

const nl_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wordt hexadecimaal weergegeven in hoofd- of kleine letters?`)
};

const fr_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'hexadécimal est-il affiché en majuscules ou en minuscules ?`)
};

const it_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'esadecimale è mostrato in maiuscole o minuscole?`)
};

const pt_br2_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hexadecimal é mostrado em maiúsculas ou minúsculas?`)
};

const pt_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O hexadecimal é apresentado em maiúsculas ou minúsculas?`)
};

const ja_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六進法は大文字で表示されますか、それとも小文字ですか？`)
};

const zh_nb_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十六进制显示的是大写还是小写？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_faq4_q", locale)
	if (locale === "en") return en_nb_faq4_q(inputs)
	if (locale === "es") return es_nb_faq4_q(inputs)
	if (locale === "de") return de_nb_faq4_q(inputs)
	if (locale === "nl") return nl_nb_faq4_q(inputs)
	if (locale === "fr") return fr_nb_faq4_q(inputs)
	if (locale === "it") return it_nb_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_nb_faq4_q(inputs)
	if (locale === "pt") return pt_nb_faq4_q(inputs)
	if (locale === "ja") return ja_nb_faq4_q(inputs)
	return zh_nb_faq4_q(inputs)
};